module.exports = __webpack_public_path__ + "static/media/datasheet_listData_row4_certificate.0104edf1.png";